var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-data-table',_vm._g(_vm._b({attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"item-class":"pa-10 red","footer-props":{
    showFirstLastPage: true,
    firstIcon: 'fa-solid fa-angles-left',
    lastIcon: 'fa-solid fa-angles-right',
  }},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,slot){return {key:slot,fn:function(scope){return [_vm._t(slot,null,null,scope)]}}})],null,true)},'v-data-table',[_vm.$attrs, _vm.$props],false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }